import { gql } from '@apollo/client';

export const GET_ALL_PAYMENT_AND_SHIPPING_METHODS = gql`
  query GetAllPaymentAndShippingMethods {
    paymentMethods {
      total_count
      methods {
        code
        title
      }
    }
    shippingMethods {
      total_count
      methods {
        code
        carrier_title
        method_title
      } 
    }
  }
`;
